<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Expandable Data</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.email">
                    {{ tr.email }}
                  </vs-td>

                  <vs-td :data="tr.username">
                    {{ tr.name }}
                  </vs-td>

                  <vs-td :data="tr.website">
                    {{ tr.website }}
                  </vs-td>

                  <vs-td :data="tr.id">
                    {{ tr.id }}
                  </vs-td>
                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users">
                      <div class="con-btns-user">
                        <div class="con-userx">
                          <vs-avatar
                            :badge="tr.id"
                            size="45px"
                            :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"
                          />
                          <span>
                            {{ tr.name }}
                          </span>
                        </div>

                        <div>
                          <vs-button
                            vs-type="border"
                            size="small"
                            class="mx-1"
                            icon="phone_in_talk"
                          ></vs-button>
                          <vs-button
                            vs-type="gradient"
                            size="small"
                            class="mx-1"
                            color="success"
                            icon="send"
                          ></vs-button>
                          <vs-button
                            vs-type="flat"
                            size="small"
                            class="mx-1"
                            color="danger"
                            icon="delete_sweep"
                          ></vs-button>
                        </div>
                      </div>
                      <vs-list>
                        <vs-list-item
                          icon="mail"
                          title="Email"
                          :subtitle="tr.email"
                        ></vs-list-item>
                        <vs-list-item
                          icon="check"
                          title="Website"
                          :subtitle="tr.website"
                        ></vs-list-item>
                      </vs-list>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Edit Data Table</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Nro1 </vs-th>
                <vs-th> Nro2 </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.email">
                    {{ tr.email }}

                    <template slot="edit">
                      <vs-input
                        v-model="tr.email"
                        class="inputx"
                        placeholder="Email"
                      />
                    </template>
                  </vs-td>

                  <vs-td :data="tr.username">
                    {{ tr.username }}

                    <template slot="edit">
                      <vs-select label="Users" v-model="tr.username">
                        <vs-select-item
                          :key="index"
                          :vs-value="item.name"
                          :vs-text="item.name"
                          v-for="(item, index) in users"
                        />
                      </vs-select>
                    </template>
                  </vs-td>

                  <vs-td :data="tr.id">
                    {{ tr.id }}

                    <template slot="edit">
                      <vs-input-number v-model="tr.id" />
                    </template>
                  </vs-td>

                  <vs-td :data="tr.id">
                    {{ tr.id }}

                    <template slot="edit">
                      <vs-slider :max="20" v-model="tr.id" />
                    </template>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Filter and Sorter</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table search :data="users">
              <template slot="thead">
                <vs-th sort-key="email"> Email </vs-th>
                <vs-th sort-key="username"> Name </vs-th>
                <vs-th sort-key="id"> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].username }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Miscellaneous</h6>
              You can add a filtered, sorted, paginated and multi selected table with combination of the search, multiple and pagination properties for example
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table
      multiple
      v-model="selected"
      pagination
      max-items="3"
      search
      :data="users">
      <template slot="header">
        <h3>
          Users
        </h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="email">
          Email
        </vs-th>
        <vs-th sort-key="username">
          Name
        </vs-th>
        <vs-th sort-key="website">
          Website
        </vs-th>
        <vs-th sort-key="id">
          Nro
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].username}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].website}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <pre>{{ selected }}</pre>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
    selected: [],
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
      {
        id: 4,
        name: "Patricia Lebsack",
        username: "Karianne",
        email: "Julianne.OConner@kory.org",
        website: "kale.biz",
      },
      {
        id: 5,
        name: "Chelsey Dietrich",
        username: "Kamren",
        email: "Lucio_Hettinger@annie.ca",
        website: "demarco.info",
      },
      {
        id: 6,
        name: "Mrs. Dennis Schulist",
        username: "Leopoldo_Corkery",
        email: "Karley_Dach@jasper.info",
        website: "ola.org",
      },
      {
        id: 7,
        name: "Kurtis Weissnat",
        username: "Elwyn.Skiles",
        email: "Telly.Hoeger@billy.biz",
        website: "elvis.io",
      },
      {
        id: 8,
        name: "Nicholas Runolfsdottir V",
        username: "Maxime_Nienow",
        email: "Sherwood@rosamond.me",
        website: "jacynthe.com",
      },
      {
        id: 9,
        name: "Glenna Reichert",
        username: "Delphine",
        email: "Chaim_McDermott@dana.io",
        website: "conrad.com",
      },
      {
        id: 10,
        name: "Clementina DuBuque",
        username: "Moriah.Stanton",
        email: "Rey.Padberg@karina.biz",
        website: "ambrose.net",
      },
    ],
  }),
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/components/tables.scss";
</style>
